<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue'
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useAppearanceStore } from '@/stores/appearance'
import BackgroundLayer from '@/components/BackgroundLayer.vue'

const auth = useAuthStore()
const appearance = useAppearanceStore()
const navigationError = ref(false)
function showNavigationError(): void {
  navigationError.value = true
}
function reload(): void {
  window.location.reload()
}
window.addEventListener('pulsewatch:navigation-error', showNavigationError)
onBeforeUnmount(() =>
  window.removeEventListener('pulsewatch:navigation-error', showNavigationError),
)
watch(
  () => [auth.token, auth.authenticated] as const,
  ([token, authenticated]) =>
    void appearance.initialize(token, authenticated).catch(() => undefined),
  { immediate: true },
)
</script>

<template>
  <BackgroundLayer />
  <div
    v-if="navigationError"
    role="alert"
    class="popup fixed bottom-6 left-1/2 z-[110] flex -translate-x-1/2 items-center gap-4 p-4"
  >
    <span class="text-sm">{{ $t('design.navigationFailed') }}</span
    ><button type="button" class="btn-quiet" @click="reload">{{ $t('common.tryAgain') }}</button>
  </div>
  <RouterView />
</template>
